<template>
  <div class="pt-4 pb-24 px-4">
    <h3 class="text-3xl font-bold mb-5">{{ $t('security') }}</h3>

    <template v-if="!is_2fa_enabled && !is_show_qr_code">
      <div class="mt-3">
        <div class="rounded-xl px-3 py-3 flex flex-col border" :class="[$theme.cardBg, $theme.cardBorderColor]">
          <div class="font-semibold">{{ $t('2fa_auth') }}</div>
          <div class="mb-3 text-sm">
            {{ $t('enable_2fa_desc') }}
          </div>
          <button
            @click="enable2FA"
            class="flex w-full items-center justify-center rounded-xl px-3 py-3 font-semibold"
            :class="[
              isFormProcessing ? 'opacity-50 pointer-events-none' : '',
              $theme.bgBtn,
              $theme.whiteText,
            ]"
          >
            {{ $t('enable_2fa') }}
          </button>
        </div>
      </div>
    </template>

    <template v-if="!is_2fa_enabled && is_show_qr_code">
      <div class="mt-3">
        <div class="rounded-xl border" :class="[$theme.baseBg, $theme.activeTabBorder]">
          <div class="flex gap-3 border-b p-3" :class="[$theme.activeTabBorder]">
            <div class="p-1">
              <QrCodeIcon class="w-8 h-8" />
            </div>
            <div class="">
              <div>
                {{ $t('setup_2fa_you_device') }}
              </div>
              <div class="text-xs opacity-70">{{ $t('scan_qr_code') }}</div>
            </div>
          </div>
          <div class="p-3">
            <div v-if="qrcode" class="flex items-center justify-center flex-col border-b pb-4" :class="[$theme.cardBorderColor]">
              <img :src="qrcode" alt="QR Code">
              <p class="text-sm my-3 opacity-70">{{ $t('scan_qr_code_or') }}</p>
              <div class="w-full border p-2 rounded-lg flex items-center justify-between" :class="[$theme.inputBorderColor, $theme.cardBg]">
                <input
                  readonly
                  v-model="code_manual"
                  type="text"
                  id="code_manual"
                  ref="code_manual"
                  class="bottom-0 p-0 border-transparent focus:outline-transparent focus:shadow-none focus:border-transparent focus:ring-0 rounded-lg bg-transparent"
                />
                <button @click="copyToClipboard" class=" text-sm border px-2 py-0.5 rounded-full" :class="[$theme.borderOrange, $theme.textOrange, $theme.baseBg]">{{ $t('copy') }}</button>
              </div>
            </div>
            <form @submit.prevent="verify2FA" class="pt-3 pb-3 border-t" :class="[$theme.activeTabBorder]">
              <label for="2fa_code" class="block text-sm mb-2">{{ $t('enter_2fa_code') }}</label>
              <input
                  type="text"
                  v-model="code"
                  id="2fa_code"
                 class="block w-full rounded-lg border shadow-sm py-2 ring-1 ring-inset focus:ring-2 focus:ring-inset focus:border-transparent"
                :class="[
                  $theme.baseTextColor,
                  $theme.inputPlaceTextColor,
                  $theme.inputRingFocusColor,
                  $theme.inputBorderColor,
                  $theme.inputRingColor,
                  $theme.cardBg,
                ]"
              />
              <div class="mt-5">
                <button
                  type="submit"
                  class="flex w-full items-center justify-center rounded-xl px-3 py-3 font-semibold"
                  :class="[
                    isFormProcessing ? 'opacity-50 pointer-events-none' : '',
                    $theme.bgBtn,
                    $theme.whiteText,
                  ]"
                >
                  <template v-if="isFormProcessing">
                    <ButtonSpinner />
                  </template>
                  {{ $t('check') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>

    <template v-if="is_2fa_enabled">
      <div class="mt-3">
        <div class="rounded-xl px-3 py-4" :class="[$theme.cardBg]">
          <div class="flex flex-col items-center justify-center">
            <ShieldCheckIcon class="w-10 h-10 text-green-500" />
            <div class="mt-2 font-semibold" :class="[$theme.baseTextColor]">{{ $t('2fa_enabled') }}</div>
            <p class="text-sm text-center" :class="[$theme.cardLabelTextColor]">
              {{ $t('2fa_enabled_desc') }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {addBackButton, hideBackButton} from "@/helpers/telegramHelper";
import QrCodeIcon from "@/components/icons/QrCodeIcon.vue";
import {ShieldCheckIcon} from "@heroicons/vue/24/solid";
import ButtonSpinner from "@/components/ButtonSpinner.vue";

export default {
  components: {
    ButtonSpinner,
    QrCodeIcon,
    ShieldCheckIcon
  },

  methods: {
    async enable2FA() {
      try {
        const response = await this.$api.post('/2fa/enable');
        this.qrcode = response.data.qrcode;
        this.code_manual = response.data.code_manual;
        this.is_show_qr_code = true;
      } catch (error) {
        console.error('Error enabling 2FA:', error);
      }
    },
    async verify2FA() {
      this.isFormProcessing = true;

      try {
        const response = await this.$api.post('/2fa/verify', {
          the_2fa_code: this.code
        });

        console.log(response);
        this.isFormProcessing = false;
        this.is_2fa_enabled = true;
        this.is_show_qr_code = true;
      } catch (error) {
        alert(this.$t('invalid_2fa_code'));
        this.isFormProcessing = false;
      }
    },

    copyToClipboard() {
      const copyText = this.$refs.code_manual;
      copyText.select();
      document.execCommand('copy');
      alert(this.$t('copied_setup_key') + ' ' + this.code_manual);
    }
  },

  data() {
    return {
      error: null,
      code: '',
      qrcode: '',
      code_manual: '',

      is_2fa_enabled: this.$user.is_2fa_enabled,
      is_show_qr_code: false,

      isFormProcessing: false,
    }
  },

  mounted() {
    addBackButton(this.$router);
  },

  beforeUnmount() {
    hideBackButton();
  }
}
</script>